import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Link } from "react-router-dom";
import { getLanguage } from '../../store/apiWrapper';
import { popupActions } from "../../store/popupStore";
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';

import SvgBBiconsFeedback from '../../img/icons/BBicons_Feedback'

import "./footer.scss";

class Footer extends React.Component {
    state = {
        agentLanguage: "",
        cribisUrl: "",
        repiUrl: ""
    }

    constructor(props) {
        super(props);

        if (!isNullOrUndefined(props.user.authentication.profile))
            this.state.agentLanguage = props.user.authentication.profile.agentLanguage;
        else
            this.state.agentLanguage = getLanguage();

        this.state.cribisUrl = `https://www.cribis.${window.location.origin.endsWith("cz") ? "cz" : "sk"}`;
        this.state.repiUrl = "https://www.repi.cz";
    }

    componentDidUpdate() {
        const agentLanguage = !isNullOrUndefined(this.props.user.authentication.profile) ? this.props.user.authentication.profile.agentLanguage : getLanguage()
        if (this.state.agentLanguage !== agentLanguage) {
            this.setState({ agentLanguage });
        }
    }

    render() {
        return (
            <footer className="footer print-hidden" >
                <div className="footer-bottom">
                    <div>
                        <Translate id="Footer.Copyright" /> <Translate id={this.getCompanyTranslationKey()} /> | <Translate id="Footer.AllRightsReserved" />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', flex: 'none' }}>
                        {this.props.public ?
                            <>
                                {isRepiWeb()
                                    ? <a href={`${this.state.repiUrl}/ochrana-osobnich-udaju/`} rel="noopener noreferer" target="_blank" className="bb-footer-links"><Translate id="Footer.PersonalData" /></a>
                                    : <>
                                        <Link className="bb-footer-links" to="/privacy-policy"><Translate id="Footer.PersonalData" /></Link>
                                        &nbsp;|&nbsp;
                                        <Link className="bb-footer-links" to="/cookie-info-link"><Translate id="Footer.Cookie" /></Link>
                                    </>
                                }&nbsp;|&nbsp;

                                <a className="bb-footer-links" onClick={() => this.UC_UIshowSecondLayer()}>
                                    <Translate id="Footer.CookieSettings" />
                                </a>&nbsp;|&nbsp;

                                {isRepiWeb()
                                    ? <a href={`${this.state.repiUrl}/kontakt`} rel="noopener noreferer" target="_blank" className="bb-footer-links"><Translate id="Footer.PersonalData" /></a>
                                    : <a href={`${this.state.cribisUrl}/kontakt`} rel="noopener noreferer" target="_blank" className="bb-footer-links"><Translate id="Contact" /></a>
                                }
                            </>
                            : <>
                                <Link to="" className="bb-footer-links" onClick={(e) => {
                                    e.preventDefault();
                                    this.openPopup();
                                }
                                }>
                                    <SvgBBiconsFeedback style={{ width: '2.5em', height: '2.5em', marginRight: '.5em' }} /> <Translate id="Feedback" />
                                </Link> &nbsp;|&nbsp;

                                {isRepiWeb()
                                    ? <a href={`${this.state.repiUrl}/ochrana-osobnich-udaju/`} rel="noopener noreferer" target="_blank" className="bb-footer-links"><Translate id="Footer.PersonalData" /></a>
                                    : <Link className="bb-footer-links" to="/personal-data/cribis"><Translate id="Footer.PersonalData" /></Link>
                                }&nbsp;|&nbsp;

                                <a className="bb-footer-links" onClick={() => this.UC_UIshowSecondLayer()}>
                                    <Translate id="Footer.CookieSettings" />
                                </a>&nbsp;|&nbsp;

                                <Link className="bb-footer-links" to="/contact"><Translate id="Contact" /></Link>
                            </>
                        }
                    </div>
                </div>
            </footer>
        );
    }

    openPopup = () => {
        this.props.showPopup("feedbackPopup",
            {
                open: true,
                style: { maxHeight: '100%' },
                ok: () => { },
                close: () => { this.props.hidePopup(); }
            })
    }

    UC_UIshowSecondLayer = () => {
        if (window.UC_UI && window.UC_UI.isInitialized()) {
            window.UC_UI.showSecondLayer()
        } else {
            window.addEventListener('UC_UI_INITIALIZED', function (e) {
                window.UC_UI.showSecondLayer()
            });
        }
    }

    getCompanyTranslationKey = () => isRepiWeb()
        ? (this.state.agentLanguage === "sk-SK" ? "Common.Repi.Sk" : "Common.Repi.Cz")
        : (this.state.agentLanguage === "sk-SK" ? "Common.Crif.Sk" : "Common.Crif.Cz");
}

export default connect(
    state => ({ user: state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, popupActions), dispatch)
)(Footer);
